import { Record } from 'immutable';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  sourceMapping: {
    id: null,
    dealer_id: null,
  },
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SOURCE_MAPPING_SUCCESS:
    case types.CREATE_SOURCE_MAPPING_SUCCESS:
    case types.UPDATE_SOURCE_MAPPING_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('sourceMapping', payload);
    case types.SOURCE_MAPPING_REQUEST:
    case types.CREATE_SOURCE_MAPPING_REQUEST:
    case types.UPDATE_SOURCE_MAPPING_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.SOURCE_MAPPING_FAILURE:
    case types.CREATE_SOURCE_MAPPING_FAILURE:
    case types.UPDATE_SOURCE_MAPPING_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_SOURCE_MAPPING:
      return state.set('sourceMapping', {
        ...requestReducerState().sourceMapping,
        dealer_id: action.payload,
      });
    default:
      return state;
  }
};
